/* eslint-disable max-len */
import React, { Component } from 'react';
import Button from 'antd/es/button/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Card from 'antd/es/card';
import Flex from 'antd/es/flex';
import Divider from 'antd/es/divider';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';
import Text from 'antd/es/typography/Text';
import { observer } from 'mobx-react';
import { RoutesConfig } from '../../../config';
import { IResetPasswordForm } from '../store';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';

const routesConfig = new RoutesConfig();

class ResetPassword extends Component<IRootStoreProps> {
  componentDidMount() {
    const path = window.location.pathname;
    const token = path.split('/').pop();
    console.log(token);
    this.props.store.auth.setResetToken(token);
  }

  componentWillUnmount(): void {
    this.props.store.dispose();
  }

  render() {
    const { store } = this.props;
    return (
      <Card title="Сброс пароля" style={{ width: '100%' }}>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          onFinish={store.auth.resetPassword}
          layout="vertical"
          autoComplete="off"
        >
          {store.requestSuccess ? (
            <Flex justify="center" align="center" vertical>
              <Text style={{ marginBottom: 30 }}>
                {'Новый пароль успешно сохранен! Перейдите на страницу входа и введите Email и новый пароль.'}
              </Text>
              <Link to={routesConfig.login}>
                <Button color="default" variant="outlined">
                  Войти
                </Button>
              </Link>
              <Divider />
            </Flex>
          ) : (
            <>
              <Text>{'Для продолжения введите новый пароль'}</Text>
              <Form.Item<IResetPasswordForm>
                style={{ paddingTop: 30 }}
                label="Пароль"
                name="password"
                rules={[
                  { required: true, message: 'Пожалуйста введите ваш пароль!' },
                  {
                    min: 8,
                    max: 30,
                    pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/,
                    message:
                      'Пароль должен быть от 8 до 30 символов и содержать как минимум одну цифру, одну латинскую строчную и заглавную букву.',
                  },
                ]}
                validateTrigger="onSubmit"
              >
                <Input.Password />
              </Form.Item>
              <Form.Item<IResetPasswordForm>
                label="Повторите пароль"
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: 'Пожалуйста введите ваш пароль еще раз!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(new Error('Пароли должны совпадать!'));
                    },
                  }),
                ]}
                validateTrigger="onSubmit"
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={store.loading}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  {'Сохранить пароль'}
                </Button>
              </Form.Item>
            </>
          )}
          {store.requestError && <Alert message="Error" description={store.requestError} type="error" showIcon />}
        </Form>
      </Card>
    );
  }
}

export const ResetPasswordPage: WithoutStore = withStore(observer(ResetPassword));
